import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAdminAuth, PlatformRole } from '@/context/AdminAuthContext';

interface Props {
  roles: PlatformRole[];
  children: React.ReactNode;
}

/**
 * Admin panel sahifalarini platforma roli bo'yicha himoyalaydi.
 * Menyudagi rol ro'yxati bilan aynan mos bo'lishi kerak (AdminLayout navGroups).
 */
export default function RequireAdminRole({ roles, children }: Props) {
  const { t } = useTranslation();
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return <div className="p-8 text-sm text-muted-foreground">{t('mkt_admin_role.loading')}</div>;
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!roles.includes(admin.role)) {
    return (
      <div className="p-8">
        <div className="max-w-md rounded-lg border border-border bg-card p-6">
          <h2 className="text-base font-semibold text-foreground">{t('mkt_admin_role.noAccessTitle')}</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            {t('mkt_admin_role.noAccessText')}
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
